package learning.containers


import com.jingfangpai.api.clients.ContentApiClient
import community.components.Topics
import learning.components.TcmFaqs
import react.*
import react.dom.div
import setTitle

external interface TcmFaqsPageProps : RProps {

}

data class TcmFaqsPageContextData(var query:(query:com.jingfangpai.content.model.ContentQuery, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.content.model.ContentVo>>) -> Unit, errorCallback: (exception:Throwable) -> Unit) -> Unit)

val TcmFaqsPageContext = createContext(TcmFaqsPageContextData(ContentApiClient::query))

val TcmFaqsPageProvider = functionalComponent<TcmFaqsPageProps> { props ->

    setTitle("常见问题")

    useEffectOnce { }

    TcmFaqsPageContext.Provider(TcmFaqsPageContextData(ContentApiClient::query)) {
        div("TcmFaqsPage") {
            child(TcmFaqs) {

            }
        }
    }
}
